import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['container', 'element']
  connect() {
    if (document.documentElement.hasAttribute("data-turbolinks-preview") === true) {
      // turbolinks caching makes events trigger twice
      // so do nothing if we are seeing the preview!
      return
    }
    if(this.hasContainerTarget) {
      this._scrollToContainer();
    }
    if(this.hasElementTarget) {
      if(this.elementTarget.nodeName.toLowerCase() == 'input') {
        const mql = window.matchMedia('(max-width: 1024px)');
        if(mql.matches) {
          this.elementTarget.addEventListener('focus', () => {
            this._scrollTo(this.elementTarget.getAttribute('data-scroll-type'))
          })
        }
      } else {
        this._scrollTo(this.elementTarget.getAttribute('data-scroll-type'))
      }
    }
  }

  _scrollToContainer() {
    if(this.hasContainerTarget) {
      const position = this.containerTarget.getAttribute('data-scroll-to-position') || 'last';
      const scrollToElement = (position == 'last') ? this.containerTarget.lastElementChild : this.containerTarget.firstElementChild;
      scrollToElement && scrollToElement.scrollIntoView()
    }
  }

  _scrollTo(position = 'top') {
    if(position == 'top') {
      const y = window.pageYOffset + this.elementTarget.getBoundingClientRect().top - this.elementTarget.getBoundingClientRect().height;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      })
    }
  }
}